module.exports = __webpack_public_path__ + "img/homePage2.ced23cd0.png";